<template>
    <div>
        <el-button :loading="loading"
                   @click="refresh"
                   icon="el-icon-refresh-right"
                   size="mini">
            重新載入
        </el-button>
        <el-button :loading="loading"
                   @click="toExcel"
                   icon="el-icon-document"
                   size="mini"
                   type="primary"
        >
            匯出
        </el-button>
        <el-button
                :icon="showFilter ? 'el-icon-remove-outline': 'el-icon-circle-plus-outline'"
                @click="showFilter = !showFilter"
                size="mini"
                type="success"
        >
            過濾器
        </el-button>
        <el-collapse-transition>
            <el-card
                    shadow="never"
                    style="margin: 2px 0;"
                    v-if="showFilter"
            >
                <el-form :model="filter" label-width="120px">
                    <el-row>
                        <el-col :xl="6">
                            <el-form-item label="申請人">
                                <el-input
                                        clearable
                                        placeholder="請輸入申請人"
                                        v-model="filter.name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="6">
                            <el-form-item label="場地">
                                <el-select
                                        clearable
                                        filterable
                                        multiple
                                        placeholder="請選擇場地(多選)"
                                        v-model="filter.roomIds"
                                >
                                    <el-option
                                            :key="r.id"
                                            :label="r.name"
                                            :value="r.id"
                                            v-for="r in rooms"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="6">
                            <el-form-item label="類型">
                                <el-select
                                        clearable
                                        filterable
                                        multiple
                                        placeholder="請選擇類型(多選)"
                                        v-model="filter.types"
                                >
                                    <el-option
                                            :key="t.value"
                                            :label="t.label"
                                            :value="t.value"
                                            v-for="t in formTypes"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xl="8">
                            <el-form-item label="申請日期起訖">
                                <el-date-picker
                                        :picker-options="{firstDayOfWeek:1}"
                                        end-placeholder="請選擇結束日期"
                                        range-separator="到"
                                        start-placeholder="請選擇開始日期"
                                        type="daterange"
                                        v-model="filter.range"
                                        value-format="yyyy-MM-dd"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
        </el-collapse-transition>
        <el-divider v-if="showFilter">分隔線</el-divider>
        <el-table
                :data="pagedForms"
                :stripe="true"
                empty-text="本學期無表單"
                height="610px"
                size="small"
                row-key="id"
        >
            <el-table-column
                    label="#"
                    prop="idx"
                    width="50">
            </el-table-column>
            <el-table-column
                    label="申請時間"
                    prop="createdAt"
            ></el-table-column>
            <el-table-column
                    label="類型"
                    prop="type"
            >
                <template #default="{row}">
                    {{`${getFormTypeStr(row.type)}${(row.comment ? `(註記:${row.comment})` : '')}`}}
                </template>
            </el-table-column>
            <el-table-column
                    label="場地"
            >
                <template #default="{row}">
                    {{roomName(row)}}
                </template>
            </el-table-column>
            <el-table-column
                    label="申請人"
            >
                <template #default="{row}">
                    {{row.applicant.name}} ({{row.applicant.shortDepartmentName}})
                </template>
            </el-table-column>
            <el-table-column
                    label="目前狀態"
                    prop="status"
            ></el-table-column>
            <el-table-column
                    label="操作"
            >
                <template #default="{row}">
                    <el-button
                            @click="selectAndShow(row)"
                            size="small"
                            type="primary"
                    >
                        詳細
                    </el-button>
                    <el-button
                            @click="deleteForm(row)"
                            size="small"
                            type="danger"

                    >直接刪除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                :current-page.sync="currentPage"
                :page-size="pageSize"
                :total="filteredForms.length"
                @current-change="page => pageChange(page, filteredForms)"
                background
                layout="total, prev, pager, next"
                style="margin-top: 10px;"
        ></el-pagination>
        <el-dialog
                v-if="show"
                :visible.sync="show"
                top="5vh"
                :title="title"
        >
            <normal-form
                    :form="selectedForm"
                    v-if="!isDrawableForm"
            ></normal-form>
            <drawable-form
                    :form="selectedForm"
                    v-else
            ></drawable-form>
            <div v-if="signHistory.length">
                <span>簽核歷史:</span>
                <div :key="history.signedAt" v-for="history in signHistory">
                    {{history.signer.name}} 簽於 {{history.signedAt}} 擬辦或意見: {{history.todo}}
                </div>
            </div>
            <template #footer>
                <el-button @click="show = false">關閉</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import formTableMixin from '../../formTableMixin';
    import moment from 'moment';

    const defaultFilter = {
        roomIds: [],
        range: undefined,
        types: [],
        name: undefined,
    };
    export default {
        name: 'BookingManage',
        data: () => ({
            pageSize: 12,
            formType: 'all',
            showFilter: false,
            filter: {...defaultFilter},
        }),
        computed: {
            ...mapState('manage', ['forms']),
            ...mapState('setting', ['sys', 'rooms']),

            filteredForms() {
                const {roomIds, range, types, name} = this.filter;
                return this.forms
                    .filter(f =>
                        roomIds.length === 0 || roomIds.some(r => r === f.roomId))
                    .filter(f => (!range || range.length === 0 || moment(f.createdAt)
                        .isBetween(range[0], range[1], 'd', '[]')))
                    .filter(f =>
                        types.length === 0 || types.some(s => s === f.type))
                    .filter(f => !name || f.applicant.name.indexOf(name) !== -1)
                    ;
            },

            formTypes() {
                return [
                    {value: 1, label: '預約登記表'},
                    {value: 2, label: '抽籤登記表'},
                    {value: 3, label: '管理者登記'}
                ];
            }
        },
        mixins: [formTableMixin],
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            ...mapActions('manage', {
                getForms: 'getFormsAction',
                deleteFormOf: 'deleteFormAction',
            }),
            ...mapActions({
                exportExcel: 'exportExcelAction'
            }),

            async deleteForm({id}) {
                try {
                    await this.$confirm('確定要刪除嗎?(刪除後將不能回復)', {
                        type: 'danger',
                    });
                    const {success} = await this.deleteFormOf(id);

                    if (success) {
                        this.$message.success('刪除成功');
                    } else {
                        this.$message.warning('刪除失敗，請重試一次');
                    }
                } catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
            },

            async refresh() {
                await this.getForms();
            },

            async toExcel() {
                const {currentSchoolYear, currentSemester} = this.sys;
                await this.exportExcel({
                    fileName: `${currentSchoolYear}${currentSemester}表單紀錄.xlsx`,
                    type: this.formType
                });
            },

            onTypeChange(type) {
                this.pagedForms = this
                    .pageData(this.filteredForms);
            }
        }
        ,
        watch: {
            filteredForms(current) {
                this.pagedForms = this.pageData(current, 1);
                this.currentPage = 1;
            }
        }
        ,
        async created() {
            await this.getForms();
        }
    }
</script>

<style>

</style>